<template>
  <footer>
    <div class="py-4">
      <b-container>
        <b-row>
          <b-col cols="5" md="6" class="text-left">
            <a 
              class="footer-brand d-none d-md-flex" 
              href="#home"
              @click="scrollIntoView"
              aria-label="Back to top">
              <img src="/brand/white-horizontal.svg" width="140" alt="Professional Portfolio - back to top">
            </a>
            <a
              class="footer-brand d-flex d-md-none" 
              href="#home"
              @click="scrollIntoView"
              aria-label="Back to top">
              <img src="/brand/white-color-short.svg" width="40" alt="Professional Portfolio - back to top">
            </a>
          </b-col>
          <b-col cols="7" md="6">
            <div class="social-net ml-auto d-flex justify-content-between">
              <a href="https://twitter.com/noeleo25" target="_blank" class="link-accent link-circle" rel="noreferrer"
              aria-label="Follow me on twitter">
                <i class="fab fa-twitter"></i>
              </a>
              <a href="https://github.com/noeleo25" target="_blank" class="link-accent link-circle" rel="noreferrer"
              aria-label="Check my github repository">
                <i class="fab fa-github-alt"></i>
              </a>
              <a href="https://www.linkedin.com/in/noemileonu/" target="_blank" class="link-accent link-circle" rel="noreferrer"
              aria-label="Contact me on LinkedIn">
                <i class="fab fa-linkedin-in"></i>
              </a>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </footer>
</template>

<script>
  export default {
    methods: {
      scrollIntoView(evt) {
        evt.preventDefault()
        const href = evt.target.getAttribute('href');
        console.log(href);
        const el = href ? document.querySelector(href) : null
        if (el) {
          window.scrollTo({ top: el.offsetTop, behavior: 'smooth' });
        }
      },
    },
  }
</script>

<style scoped>
footer{
  background: #2C2B30;
}
.footer-brand > img{
  pointer-events: none;
}
.social-net{
  height: 100%;
  align-items: center;
}
.link-circle{
  color: #fff;
  border-color: #fff;
}
</style>